import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * Composant de tracking simplifié et sécurisé
 * À utiliser uniquement à l'intérieur d'un RouterProvider
 */
export const AnalyticsTrackerWrapper = () => {
  const location = useLocation();
  let user = null;
  
  try {
    const authContext = useAuth();
    user = authContext?.user || null;
  } catch (error) {
    // Si le contexte n'est pas disponible, continuer sans user
  }

  useEffect(() => {
    // Mettre à jour l'ID utilisateur si connecté
    try {
      import('@/services/analytics.service').then(({ analyticsTracker }) => {
        if (user?.id) {
          analyticsTracker.setUserId(user.id);
        } else {
          analyticsTracker.setUserId(null);
        }
      }).catch(() => {
        // Ignorer si le service n'est pas disponible
      });
    } catch (error) {
      // Ignorer les erreurs
    }
  }, [user]);

  useEffect(() => {
    // Track chaque changement de page
    try {
      const pageUrl = window.location.href;
      const pageTitle = document.title;

      setTimeout(() => {
        import('@/services/analytics.service').then(({ analyticsTracker }) => {
          analyticsTracker.trackPageView(pageUrl, pageTitle).catch((error) => {
            console.error('Erreur tracking page view:', error);
          });
        }).catch(() => {
          // Ignorer si le service n'est pas disponible
        });
      }, 100);
    } catch (error) {
      console.error('Erreur dans le tracking de page:', error);
    }
  }, [location]);

  useEffect(() => {
    // Détecter les paniers abandonnés lors de la fermeture de la page
    const handleBeforeUnload = async () => {
      try {
        const cartData = localStorage.getItem('cart');
        if (cartData) {
          const cart = JSON.parse(cartData);
          if (cart.length > 0) {
            import('@/services/analytics.service').then(({ analyticsTracker }) => {
              analyticsTracker.markCartAbandoned().catch(() => {
                // Ignorer les erreurs
              });
            }).catch(() => {
              // Ignorer si le service n'est pas disponible
            });
          }
        }
      } catch (e) {
        // Ignorer les erreurs
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return null;
};
